import styled from "styled-components"
import Icon, { IconList } from "./Icon"

const SecuredBy = () => {
  return (
    <SecuredByWrapper>
      <Text>
        Secured by
      </Text>
      <OmiseIcon>
        <Icon
          src={IconList.Omise}
          style={{ height: '12px', }}
        />
      </OmiseIcon>
    </SecuredByWrapper>
  )
}

export default SecuredBy

const SecuredByWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

const Text = styled.span`
  margin-right: 8px;
  font-size: 10px;
  color: #ABB2C2;
`

const OmiseIcon = styled.span`
  position: relative;
  top: -4px;
`
